import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_11: FaireProductEntity = {
  token: "viverano-11",
  type: "product",
  name: "Pony Snuggles - Organic Cotton Jacquard Knit Baby Blanket",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/a2c66e6d3c4426b63e7b86bf1d723d360441738febb3b00810cea65837238fc0.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 38.5,
  msrpDollars: 68,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_nursery-decor"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
